export default {
	label: 'User | Users',
	validIdCode: 'ID code needs to be 11 characters long!',
	validEmail: 'Email needs to be longer than 2 characters and include {symbol}!',
	validPassword: 'Password needs to be longer than 12 characters!',
	validPassword2: 'Passwords must match!',
}
